export default __webpack_public_path__ + "1384852e62f02b1018e12551c20b4741.png";